
import { defineComponent } from 'vue';
import CustomButton from '~/components/Buttons/CustomButton.vue';
import CustomDialog from '~/components/Dialogs/CustomDialog.vue';

export default defineComponent({
  name: 'DetailsConfirmationDialog',

  components: { CustomButton, CustomDialog },

  props: {
    accountType: { type: String, required: true },
    accountNumber: { type: String, required: true },
    accountBank: { type: String, required: true },
  },

  computed: {
    lastFour(): string {
      return this.accountNumber.slice(-4);
    }
  }
});
